export default __webpack_public_path__ + "static/media/event_arrow.44132184.svg";